export var ACTION;
(function (ACTION) {
    ACTION["CONFIRM_PAN"] = "CONFIRM_PAN";
    ACTION["CHANGE_PAN_NO"] = "CHANGE_PAN_NO";
})(ACTION || (ACTION = {}));
